module.exports = __webpack_public_path__ + "img/spanish.78b51eb2.jpeg";